import { render, staticRenderFns } from "./UpdateTaskDateDialog.vue?vue&type=template&id=03863208"
import script from "./UpdateTaskDateDialog.vue?vue&type=script&lang=js"
export * from "./UpdateTaskDateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports